export default function () {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1975_20363)">
                <path
                    d="M25.5 3.375H10.5C9.67157 3.375 9 4.04657 9 4.875V31.125C9 31.9534 9.67157 32.625 10.5 32.625H25.5C26.3284 32.625 27 31.9534 27 31.125V4.875C27 4.04657 26.3284 3.375 25.5 3.375Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15.75 6.75L20.25 6.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M19.6875 28.6875C19.6875 29.6195 18.932 30.375 18 30.375C17.068 30.375 16.3125 29.6195 16.3125 28.6875C16.3125 27.7555 17.068 27 18 27C18.932 27 19.6875 27.7555 19.6875 28.6875Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_1975_20363">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
